import { getCurrentInstance, computed, ref } from '@vue/composition-api';
import { getLocalItem } from '@/utils/paramsLocalStorage';
import { MONTH_IN_MS } from '@/utils/constants/globalConst';
import { checkMobile } from '@/utils/deviceCheck';
import useStore from '@/compositions/useStore';

const useCommonModal = () => {
  const store = useStore();
  const vm = getCurrentInstance();

  const modal = vm.root.proxy.$vfm;
  const isMobile = checkMobile();

  const forceRenderNuxt = () => store.dispatch('main/forceRenderNuxt');

  const stateAuth = ref('login');

  const titleAuth = computed({
    get: () => {
      let title = 'Войти';
      if (stateAuth.value === 'forgot') {
        title = 'Восстановление пароля';
      }
      if (['registration', 'confirmRecovery'].includes(stateAuth.value)) {
        title = 'Регистрация';
      }
      if (stateAuth.value === 'registration_success') {
        title = '';
      }
      return title;
    },
    set: () => {},
  });

  const getModalComponent = () => {
    if (isMobile) {
      return () => import('@/components/AppModal/index.vue');
    }
    return () => import('@/components/AppModal/AppModalDesktop/index.vue');
  };

  const changeAuthState = (state) => {
    stateAuth.value = state;
  };

  const hideModalAuth = () => {
    modal.hide('AuthModal');
  };

  const showAuth = () => {
    const componentBind = {
      nameModal: 'AuthModal',
    };
    const slotsComponentBind = {
      initialState: stateAuth.value,
      isMobile: true,
    };

    if (isMobile) {
      componentBind.isTransparentHeader = false;
      componentBind.titleModalRef = titleAuth;
    }

    if (!isMobile) {
      slotsComponentBind.showTitle = true;
      slotsComponentBind.style = 'width: 420px; padding: 16px;';
      slotsComponentBind.isMobile = false;
    }

    modal.show({
      component: getModalComponent(),
      bind: componentBind,
      on: {
        'before-close': () => {
          if (stateAuth.value === 'registration_success') {
            forceRenderNuxt();
          } else if (stateAuth.value === 'confirmRecovery') {
            stateAuth.value = 'registration';
          }
        },
      },
      slots: {
        default: {
          component: () => import('@/components/AuthForm/index.vue'),
          bind: slotsComponentBind,
          on: {
            hideModal: hideModalAuth,
            changeState: changeAuthState,
          },
        },
      },
    });
  };

  const hideModalInstall = () => {
    modal.hide('InstallPrompt');
  };

  const cancelledInstall = () => {
    const igA2hsDismiss = getLocalItem('ig_a2hs_dismiss');
    const currentDate = new Date();
    const diffTime = igA2hsDismiss ? ((currentDate - new Date(igA2hsDismiss)) / MONTH_IN_MS) : 0;
    return igA2hsDismiss && diffTime;
  };

  const showInstallModal = () => {
    if (cancelledInstall()) return;
    modal.show({
      component: () => import('@/components/AppModal/SmallMobileModal/index.vue'),
      bind: {
        nameModal: 'InstallPrompt',
      },
      on: {
        'before-close': () => {
          if (stateAuth.value === 'registration_success') {
            forceRenderNuxt();
          }
        },
      },
      slots: {
        default: {
          component: () => import('@/components/Install/InstallModal.vue'),
          bind: {
            initialState: stateAuth.value,
            isMobile: true,
          },
          on: {
            hideModal: hideModalAuth,
            changeState: changeAuthState,
          },
        },
      },
    });
  };

  return {
    showAuth,
    hideModalAuth,
    modal,
    titleAuth,
    changeAuthState,
    showInstallModal,
    hideModalInstall,
    getModalComponent,
  };
};

export default useCommonModal;
